// extracted by mini-css-extract-plugin
export default {"loading-container":"Loading_loading-container__czPLU","loading-container__letter":"Loading_loading-container__letter__8Vkkx","fadeIn":"Loading_fadeIn__Ri+ah"};